import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Spin } from 'antd';
import moment from 'moment';
import { BsTrash } from "react-icons/bs";

import Input from "../../components/uiComponent/inputs/labelInput/index"
import Select from "../../components/uiComponent/select/index";
import Drawer from "../../components/uiComponent/drawer/index";
import Button from "../../components/uiComponent/button/index";

import { GetLocationsList, MoveToLocation, GetLocationProducts } from '../../slices/location-management';

import { WarehouseWrapper } from "./style";
import { isEmpty } from 'lodash';
import { STORAGE_ICON_URL, STORAGE_IMAGE_URL } from '../../constants/storage';
const AddIcon = `${STORAGE_ICON_URL}/add-plus-icon.svg`;

const ProductImg = `${STORAGE_IMAGE_URL}/newImages/nestle.svg`;

const initialDistribution = {
  quantity: '',
  notes: '',
  location: {},
};

const MoveLocation = ({
  isMoveToLocation,
  setIsMoveToLocation,
  selectedIndex,
  refreshData,
  locationId
}) => {
  const dispatch = useDispatch();

  const [distributions, setDistributions] = useState([]);
  const [newDistribution, setNewDistribution] = useState({ ...initialDistribution });
  const [loading, setLoading] = useState(false);

  const {
    locationProducts,
    locationsList,
    fetchingLocationsList
  } = useSelector((state) => state?.locationManagement || {});
 
  useEffect(() => {
    dispatch(GetLocationsList());
  }, []);

  const handleDeleteEntry = (index) => {
    setDistributions((prev) => prev.filter((_, i) => i !== index));
  };

  const { quantity = 0, expiry_date, id: location_distribution_id, products_v2 } = locationProducts?.[selectedIndex] || {};
  const { name: productName, image_url } = products_v2 || {};
  const expiryDate = expiry_date ? moment(expiry_date).format('MM/DD/YYYY') : '---';

  const getAddBtnDisabledStatus = () => {
    const { quantity, location } = newDistribution || {};
    if (!quantity || quantity <= 0) return true;
    if (isEmpty(location)) return true;
    return false;
  };

  const handleSaveData = () => {
    setLoading(true);
    dispatch(MoveToLocation({
      location_distribution_id,
      distributions: distributions?.map(({
        quantity,
        notes,
        location
      }) => ({
        quantity,
        notes,
        location_id: location.value
      }))
    })).then(({ payload }) => {
      setLoading(false);
      if (payload?.success) {
        refreshData();
        setIsMoveToLocation(false);
      }
    });
  };

  return (
    <>
      <Drawer
        show={isMoveToLocation}
        size="40%"
        className='to-location-drawer-wrapper'
        style={{ borderTopLeftRadius: 10, borderBottomLeftRadius: 10 }}
      >
        <WarehouseWrapper>
          <Spin tip='Loading...' spinning={loading}>
            <div className="drawer-body">
              <div className="drawer-header-location">
                <span onClick={() => setIsMoveToLocation(false)} className="icon-arrow-left cursor-pointer" />
                <h5>Move To A Location</h5>
              </div>
              <div className="content-location-wrapper">
                <div className="item-container">
                  <div className="item-wrapper">
                    <p>Name</p>
                    <div className="item-title">
                      <img src={image_url || ProductImg} />
                      <p>{productName}</p>
                    </div>
                  </div>
                  <div className="bar-items">
                    <p>Quantity:</p>
                    <p>{quantity}</p>
                  </div>
                  <div className="bar-items">
                    <p>Expire Date:</p>
                    <p>{expiryDate}</p>
                  </div>
                </div>
                <div className="container-location-add-value">
                  <div className="inputs-ui-location">
                    <Input
                      placeholder="Enter"
                      label="Qty"
                      value={newDistribution.quantity}
                      onChange={({ target }) => setNewDistribution(newDistribution => ({ ...newDistribution, quantity: target.value || '' }))}
                    />
                    <Input
                      placeholder="Enter"
                      label="Notes (Optional)"
                      value={newDistribution.notes}
                      onChange={({ target }) => setNewDistribution(newDistribution => ({ ...newDistribution, notes: target.value || '' }))}
                    />
                    <Select
                      isClearable={true}
                      placeholder="Select"
                      label="Location"
                      className="mb-0"
                      value={isEmpty(newDistribution.location) ? '' : newDistribution.location}
                      options={locationsList.filter(location => location.label !== 'staging-location' && location.value != locationId )}
                      onChange={(e) => setNewDistribution(newDistribution => ({ ...newDistribution, location: e || {} }))}
                      loading={fetchingLocationsList}
                    />
                    <img className="add-icon" src={AddIcon} alt={AddIcon}
                      style={getAddBtnDisabledStatus() ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                      onClick={() => {
                        setDistributions(distributions => [{ ...newDistribution }, ...distributions]);
                        setNewDistribution({ ...initialDistribution });
                      }}
                    />
                  </div>
                  <div className="items-content-wrapper-location">
                    {distributions?.map((item, index) => (
                      <div key={index} className="items-content-wrapper-location-item">
                        <p>{item.quantity}</p>
                        <p>{item.notes}</p>
                        <p>{item.location?.label}</p>
                        <BsTrash className={`cursor-pointer color-danger`}
                          onClick={() => handleDeleteEntry(index)}
                        />
                      </div>
                    ))}
                  </div>
                  <div className="footer-buttons">
                    <Button className="outlined" text="Cancel" onClick={() => setIsMoveToLocation(false)} />
                    <Button
                      text="Confirm"
                      disabled={!distributions?.length}
                      onClick={handleSaveData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </WarehouseWrapper>
      </Drawer>
    </>
  );
}

export default MoveLocation